export default "/images/ship-icon-blue.png?2b967135ab61b27a45138157f91e66f9";